<template>
  <div class="notice-list-container" @scroll="handleScroll" ref="scrollEle">
    <div class="list-item-box" :class="{'is-active': +currentNotice?.id  === +item?.id}" v-for="(item,index) in messageList" :key="index" @click="onNotice(item)">
      <el-badge :hidden="+item?.is_read === 0 ? false : true" is-dot class="badge">
        <div class="icon-box">
          <svg class="icon" width="20" height="20">
            <use :xlink:href="`#${typeData(item.msg_type)?.icon}`" />
          </svg>
        </div>
      </el-badge>
      <div class="message-info">
        <p class="name">【{{typeData(item.msg_type)?.type}}】{{item.title}}</p>
        <div class="bottom-box">
          <p class="desc">{{item?.archi_name ? item?.archi_name : '-'}}</p>
          <span class="time">{{ getTime(item.created_at)}}</span>
        </div>
        <el-progress :key="'progress' + index" v-if="[2,3].includes(+item.msg_type) && +item?.progress_status !== 2" type="line" class="custom-progress" :color="getColor(item)" :show-text="false" :format="(percent) => (percent == 100 ? '执行成功' : `${percent}%`)" :percentage="getProgress(item)" :stroke-width="2" />
      </div>
    </div>
    <div  class="bottom-side">
      <span class="line"></span>
      <span class="name">{{loading ? '加载中...' : '到底啦'}}</span>
      <span class="line"></span>
    </div>
  </div>
</template>
<script>
import {Badge,Progress} from "element-ui";

export default {
  components: {
    "el-badge": Badge,
    "el-progress":Progress
  },
  props: {
    messageList:{
      type: Array,
      default: ()=>{
        return [];
      }
    },
    loading:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // scrollEle: null,
      currentNotice: {}
    };
  },
  computed: {
  },
  watch: {
    
  },
  methods:{
    getColor(data){
      if(+data?.progress_status === 3){
        return '#FF6F6F';
      }
      return '#387FFC';
    },

    getProgress(data){
      // 关于执行成功或执行失败的进度条状态，有数据则正常返回，没有数据则制造一个进度数据让用户知道该消息状态@蒋冬梅
      if(+data?.progress_status === 3 && !data?.progress){
        // const randomNumber = Math.floor(Math.random() * 99) + 1;
        return 30;
      }
      if(+data?.progress_status === 2  && !data?.progress){
        return 100;
      }
      return data?.progress;
    },



    getTime(time){
      if(time){
        const currentDate = new Date();
        const date = new Date(time);
        const currentYear = currentDate.getFullYear();
        const year = date.getFullYear();
        const currentDateString = currentDate.toISOString();
        if(time.slice(0,10)===currentDateString.slice(0,10)){
          return time.slice(time.length-9,time.length - 3);
        }else{
          if(currentYear === year){
            return time.slice(5,16);
          }
          return time.slice(0,10);
        }
      }else{
        return '-';
      }
    },

    onNotice(data){
      this.currentNotice = data;
      this.$emit('on-notice',data);
    },

    typeData(type){
      switch (+type) {
        case 1:
          // 消息通知
          return {icon: 'iconxitongtongzhi1',type: '系统'};
        case 2:
          // 执行进度
          return {icon: 'iconzhihangjindu',type: '导出'};
        case 3:
          // 任务
          return {icon: 'iconrenwu1',type: '任务'};
        case 6:
          // 评论
          return {icon: 'iconpinglun2',type: '评论'};
        case 4:
          // 会议
          return {icon: 'iconhuiyi',type: '会议'};
        case 5:
          // 预警
          return {icon: 'iconyujing3',type: '预警'};
      }
    },

    handleScroll(e){
      if (e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight - 100) {
        if (!this.loading) {
          this.$emit('scroll');
        }
      }
    },
  },
  mounted() {},
  created() {},
}
</script>
<style lang="less" scoped>
.notice-list-container{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .list-item-box{
    width: 100%;
    padding: 8px 12px;
    box-sizing: border-box;
    display: flex;
    // align-items: center;
    gap: 6px;
    overflow: hidden;
    border-radius: var(--Radio-8, 8px);
    cursor: pointer;
    &:hover,&.is-active{
      background: var(--overall-surface-default-hover, #F4F6F9);
      .icon-box{
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.00) 100%), var(--overall-surface-default, #FFF);
      }
    }
    :deep(.el-badge){
      .el-badge__content{
        width: 6px;
        height: 6px;
        top: 3px;
        right: 9px;
        background: var(--semantic-error-on-background, #FC5558);
      }
    }
    .icon-box{
      width: 36px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 32px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.00) 100%), var(--overall-surface-variant, #F2F5FA);
      flex-shrink: 0;
    }
    .message-info{
      flex: 1;
      overflow: hidden;
      position: relative;
      :deep(.custom-progress){
        width: 100%;
        position: absolute;
        left: 6px;
        bottom: 0;
        width: calc(100% - 6px);
      }
      .name{
        width: 100%;
        overflow: hidden;
        color: var(--text-on-surface-primary, #181B22);
        text-overflow: ellipsis;
        font-family: "PingFang SC";
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0.4px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        flex: 1 0 0;
      }
      .bottom-box{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 24px;
        padding-bottom: 6px;
        padding-left: 6px;
        box-sizing: border-box;
        .desc{
          flex: 1;
          color: var(--text-on-surface-tertiary, #707786);
          font-family: "PingFang SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          letter-spacing: 0.4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .time{
          flex-shrink: 0;
          color: var(--text-on-surface-placeholder, #A4ACBD);
          text-align: right;
          font-family: "PingFang SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          letter-spacing: 0.4px;
        }
      }
    }
  }
  .bottom-side{
    width: 100%;
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 23px 0 7px 0;
    box-sizing: border-box;
    .name{
      overflow: hidden;
      color: var(--text-on-surface-tertiary, #707786);
      text-overflow: ellipsis;
      font-family: "PingFang SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.4px;
    }
    .line{
      flex: 1;
      height: 1px;
      background: var(--border-on-surface-weak, #F0F1F4);
    }
  }
}
</style>
